import { useState } from "react";
import { createContainer } from "unstated-next";

type AppContext = {
  loading: boolean;
};

/**
 * アプリケーションコンテナ
 *
 * アプリケーション全体に関わる状態管理
 */
const useAppContainer = () => {
  const [context, setContext] = useState({ loading: false });

  const setLoading = (loading: boolean) => {
    if (context.loading === loading) {
      return;
    }

    context.loading = loading;
    setContext({ ...context });
  };

  return { context, setLoading };
};

export const AppContainer = createContainer(useAppContainer);
